export const IOS_URL =
  "https://itunes.apple.com/us/app/iptv-time/id1434729544?ls=1&mt=8";

export const SUPPORT_EMAIL = "carlosmsilva83@gmail.com";
